import { ModalContentProps, rem } from '@bonusly/design-system';

export const activeStyle = {
	bg: 'primary.bgAlpha',
	borderColor: 'transparent',
	color: 'primary.fgStrong',
};

export const buttonStyle = {
	_active: activeStyle,
	_hover: activeStyle,
	bg: 'bg.surface',
	borderColor: 'border.soft',
	borderRadius: 'md',
	borderStyle: 'solid',
	borderWidth: '1px',
	color: 'text.default',
	fontSize: 'md',
	fontWeight: 'normal',
	height: rem(40),
	lineHeight: rem(24),
	px: { xs: rem(16) },
	width: { base: rem(40), xs: 'auto' },
};

export const coinStyle = {
	filter:
		'drop-shadow(0px 9px 4px rgba(67, 72, 86, 0.01)) drop-shadow(0px 5px 3px rgba(67, 72, 86, 0.02)) drop-shadow(0px 2px 2px rgba(67, 72, 86, 0.03)) drop-shadow(0px 1px 1px rgba(67, 72, 86, 0.04)) drop-shadow(0px 0px 1px rgba(67, 72, 86, 0.1));',
	h: 6,
	w: 6,
};

export const modalContentStyle: Partial<ModalContentProps> = {
	height: { base: rem(448), xs: rem(512) },
	maxH: { base: 'calc(100vh - 1rem)', xs: 'calc(100vh - 7.5rem)' },
	maxW: { base: 'calc(100vw - 1rem)', xs: 'lg' },
	position: { base: 'absolute', xs: 'relative' },
	bottom: { base: '0.5rem', xs: 'unset' },
	borderRadius: 'md',
};
